export default {
  md: 992,
  sm: 768,
  xs: 576,
};
